import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { Container } from "../styles/container";
import CustomHelmet from "../components/CustomHelmet";
import styled from "styled-components";
import { Link } from "react-router-dom";
import CommonService from "../services/CommonService";
import Loader from "../components/Loader";

const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
  // padding: 20px 0px;
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;
  @media (max-width: 767px) {
    order: 1;
  }
  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.4;
    margin-bottom: 15px;
    text-transform: uppercase;
    text-align: right;

    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
`;

const Right = styled.div`
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  @media (max-width: 767px) {
    order: 2;
  }
`;

const SectionBottom = styled.section`
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 50px 0px;
`;

const Leftcard = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  overflow: hidden;
  border-radius: 12px;
  > img {
    width: 100%;
    height: 100%;
  }
  > .txt {
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    background: linear-gradient(
      100deg,
      var(--yellow) 0%,
      var(--darkYellow) 50%
    );
    > .desc {
      margin: 20px 0px;
    }
    > .box {
      position: absolute;
      width: 10px;
      height: 10px;
      left: -5px;
      top: 15px;
      transform: rotate(45deg);
      background-color: var(--yellow);
      @media (max-width: 992px) {
        display: none;
      }
    }

    > h4 {
      font-size: 20px;
      font-weight: 600;
      text-transform: capitalize;
      line-height: 1.4;
      margin-bottom: 20px;
      color: var(--white);
    }
    > p {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 20px;
      color: var(--txt);
    }
    > a {
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 0px;
      color: var(--choco);
      font-weight: 500;
      position: absolute;
      bottom: 10px;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 50px;

  > button {
    width: 30px;
    height: 30px;
    border: 1px solid var(--yellow);
    color: var(--yellow);
    cursor: pointer;
    border-radius: 0px;
    outline: none;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
  }
`;

const NewsUpdate = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState(false);
  const getBlogs = () => {
    setloading(true);
    CommonService.get("/blog/all?page=1&limit=5")
      .then((data) => setData(data))
      .catch((err) => alert(err.message))
      .finally(() => setloading(false));
  };

  useEffect(() => {
    getBlogs();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;

  // Calculate the index range for the current page
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = data?.blogs?.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(data?.blogs?.length / blogsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return loading ? (
    <Loader />
  ) : (
    <>
      <CustomHelmet
        title="Arcaptor Technologies: Revolutionizing Education with AI, Metaverse, and Simulations"
        description="Arcaptor Technologies blends AI, metaverse, and simulations to revolutionize education. Our tailored ecosystem includes SSB-GPT, Alpha Regiment, and more, crafting personalized learning journeys for defense and competitive exams like UPSC."
      />
      <MainLayout>
        <Section>
          <Container>
            <Content>
              <Right>
                <img src="./images/newsUpdateHero.png" alt="newsUpdateHero" />
              </Right>
              <Left>
                <h1>News & Update</h1>
              </Left>
            </Content>
          </Container>
        </Section>

        <Container>
          <SectionBottom>
            {currentBlogs?.length > 0 &&
              currentBlogs?.map((ele) => (
                <Leftcard key={ele?._id}>
                  <img
                    src={`${process.env.REACT_APP_IMAGE_ORIGIN}/blog/${ele?.image}`}
                    alt={ele?.image}
                  />
                  <div className="txt">
                    <h4>{ele?.title}</h4>

                    <div
                      className="desc"
                      dangerouslySetInnerHTML={{
                        __html: ele?.description?.slice(0, 600) + "...",
                      }}
                    />
                    <Link to={`/blog-detail?q=${ele?.slug}`}>Read more</Link>
                    <div className="box"></div>
                  </div>
                </Leftcard>
              ))}
          </SectionBottom>
          <Pagination className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => handlePageChange(i + 1)}
                className={currentPage === i + 1 ? "active" : ""}
              >
                {i + 1}
              </button>
            ))}
          </Pagination>
        </Container>
      </MainLayout>
    </>
  );
};

export default NewsUpdate;
